import { createStyles, Theme, Typography, WithStyles, withStyles } from '@material-ui/core'
import React from 'react'
import { INDUSTRIES, OCCUPATIONS } from '../../formAssets'
import OutcomeDropDownItem from '../../FormTemplates/CustomOutcomeDropDown/OutcomeDropDownItem'
import OutcomeTextItem from '../../FormTemplates/CustomOutcomeTextItem/OutcomeTextItem'
import CustomHoursTemplate from './CustomHoursTemplate'
import Autocomplete from 'src/components/Outcomes/Autocomplete'
import CustomAutocomplete from 'src/components/Outcomes/CustomAutocomplete'
import CustomSearchAutocomplete from 'src/components/Outcomes/CustomSearchAutocomplete'

interface OtherEnrolledActivityInformationSectionProps extends WithStyles<typeof styles> {
	wblType: string
	unpaidHours?: number
	paidHours?: number
	internshipEmployer: string
	internshipIndustry: string
	internshipOccupation: string
	onWblTypeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	onHoursChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	onInternshipEmployerChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	onInternshipIndustryChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	onInternshipOccupationChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	header: string
  unpaidHoursRequired?:boolean
  paidHoursRequired?:boolean
  serviceType?: string
  employers: any[]
}

const wblTypes = [
	'Internship',
	'Industry Project',
	'Service Learning Project',
	'School-Based Enterprise',
	'Apprenticeship',
	'Pre-Apprenticeship',
]

const careerTypes = [
	'Portfolio creation',
	'Career Panel',
	'Career Fair',
	'Field Trip/Site Visit',
	'Industry Research/Curriculum',
	'Personalized survey',
	'Job Shadow',
	'Essential Skills/Work Readiness Curriculum'
]


export const OtherEnrolledActivityInformationSection: React.FC<OtherEnrolledActivityInformationSectionProps> =
(props: OtherEnrolledActivityInformationSectionProps) => {
	const {
		classes,
		onWblTypeChange,
		wblType,
		unpaidHours,
		paidHours,
		onHoursChange,
		internshipEmployer,
		internshipIndustry,
		internshipOccupation,
		onInternshipEmployerChange,
		onInternshipIndustryChange,
		onInternshipOccupationChange,
		header,
    unpaidHoursRequired,
    paidHoursRequired,
    serviceType
	} = props

	const WBLHeader = "Work Based Activity Information"
	const wblTypeLabel = header === WBLHeader ? "Type of Work Based Activity" : "Type of Career Exploration Activity"

	return (
		<div className={classes.root} data-auto="job-placement-wrapper">
			<Typography variant="h5" className={classes.sectionSubtitle} data-auto="job-placement-label">
				{header}
			</Typography>
			<OutcomeDropDownItem
				label={wblTypeLabel}
				prop="wblType"
				value={wblType}
				onInputChange={onWblTypeChange}
				items={header === WBLHeader ? wblTypes : careerTypes}
			/>
			<CustomHoursTemplate
				label="Unpaid Hours"
				hours={unpaidHours}
				prop="unpaidHours"
				onHoursChange={onHoursChange}
        required={unpaidHoursRequired}
        serviceType={serviceType}
			/>
			<CustomHoursTemplate
				label="Paid Hours"
				hours={paidHours}
				prop="paidHours"
				onHoursChange={onHoursChange}
        required={paidHoursRequired}
        serviceType={serviceType}
			/>
			{
				(header === WBLHeader) &&
				// <OutcomeTextItem
				// 	label="Internship Employer"
				// 	placeholder="Employer name"
				// 	prop="internshipEmployer"
				// 	value={internshipEmployer || ''}
				// 	onInputChange={onInternshipEmployerChange}
				// 	required={true}
				// />

        // <Autocomplete suggestions={props.employers?.map(e=>e.employer_name)}
        //   label="Internship Employer"
        //   placeholder="Employer Name"
        //   name="internshipEmployer"
        //   value={internshipEmployer || ''}
        //   onInputChange={onInternshipEmployerChange} 
        //   required={true}
        //   />

          // <CustomAutocomplete
          //   label="Internship Employer"
          //   required={true}
          //   placeholder="Employer Name"
          //   name="internshipEmployer"
          // />

          <CustomSearchAutocomplete
            label="Internship Employer"
            required={true}
            placeholder="Employer Name"
            name="internshipEmployer"
          />
			}

			<OutcomeDropDownItem
				label={header === WBLHeader ? "Industry of Employer or Project" : "Industry Alignment"}
				prop="internshipIndustry"
				value={internshipIndustry}
				onInputChange={onInternshipIndustryChange}
				items={INDUSTRIES}
				hideUnknown={true}
				required={false}
        serviceType={serviceType}
			/>

			{
				(header === WBLHeader) &&
				<OutcomeDropDownItem
					label="Internship Occupation"
					prop="internshipOccupation"
					value={internshipOccupation}
					onInputChange={onInternshipOccupationChange}
					items={OCCUPATIONS}
					hideUnknown={true}
					fullWidth={true}
					required={false}
				/>
			}
		</div>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		root: {},
		sectionSubtitle: {
			padding: `${theme.spacing.unit}px 0`,
		},
	})

export default withStyles(styles)(OtherEnrolledActivityInformationSection)
